// Firebase configuration and initialization
// This file is used when DATABASE_TYPE=firebase is set in .env

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyANLl3Rwr3fl-glUNsrmGgTTF3kapZ27uI",
  authDomain: "sindhi-adabi-sangat.firebaseapp.com",
  projectId: "sindhi-adabi-sangat",
  storageBucket: "sindhi-adabi-sangat.firebasestorage.app",
  messagingSenderId: "154922655964",
  appId: "1:154922655964:web:b66419206e35b6341a5419",
  measurementId: "G-NCCGVVGTZ5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);

export default app;
